export default {
  errors: null,
  catalogs: [],
  loading: false,
  count: 0,
  totalCount: 0
};
